/**
 * Listing metadata API endpoint schemas
 */
import { z } from 'zod';

// Request schema for GET query parameters
export const ListingMetadataRequestSchema = z.object({
  listingId: z.coerce.number().positive('listingId is required'),
});

export type ListingMetadataRequest = z.infer<typeof ListingMetadataRequestSchema>;

// Photo schema
export const MetadataPhotoSchema = z.object({
  url: z.string(),
});

export type MetadataPhoto = z.infer<typeof MetadataPhotoSchema>;

// Response schema
export const ListingMetadataResponseSchema = z.object({
  success: z.literal(true),
  photos: z.array(MetadataPhotoSchema),
  remote_url: z.string().nullable(),
  dataSourceId: z.number().nullable(),
});

export type ListingMetadataResponse = z.infer<typeof ListingMetadataResponseSchema>;

// Error response schema
export const ListingMetadataErrorResponseSchema = z.object({
  error: z.string(),
});

export type ListingMetadataErrorResponse = z.infer<typeof ListingMetadataErrorResponseSchema>;
